// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"366":"c63db7d4","723":"c63db7d4"}[chunkId] + ".chunk.css";
};